import axios from 'axios';
import { getApiUrl } from '../../../config/api';

/**
 * API client for offer approvals. The backend takes the company and the person from
 * the signed-in identity, so nothing here sends either.
 */
const withCredentials = { withCredentials: true };

export async function getOfferPolicy() {
  const res = await axios.get(getApiUrl('/api/hiring-lifecycle/offer-policy'), withCredentials);
  return { needsApproval: Boolean(res.data?.offers_need_approval), available: Boolean(res.data?.available) };
}

export async function setOfferPolicy(needsApproval) {
  const res = await axios.put(
    getApiUrl('/api/hiring-lifecycle/offer-policy'),
    { offers_need_approval: Boolean(needsApproval) },
    withCredentials,
  );
  return Boolean(res.data?.offers_need_approval);
}

/** Where one candidate's offer draft stands: { required, status, requested_by, ... }. */
export async function getApprovalState(applicationId) {
  const res = await axios.get(
    getApiUrl(`/api/hiring-lifecycle/applications/${applicationId}/offer-approval`),
    withCredentials,
  );
  return res.data;
}

export async function askForApproval(applicationId, note = '') {
  const res = await axios.post(
    getApiUrl(`/api/hiring-lifecycle/applications/${applicationId}/offer-approval`),
    { note },
    withCredentials,
  );
  return res.data;
}

export async function getWaitingApprovals() {
  const res = await axios.get(getApiUrl('/api/hiring-lifecycle/offer-approvals'), withCredentials);
  return Array.isArray(res.data?.approvals) ? res.data.approvals : [];
}

export async function decideApproval(approvalId, approve, comment = '') {
  const res = await axios.post(
    getApiUrl(`/api/hiring-lifecycle/offer-approvals/${approvalId}/decision`),
    { decision: approve ? 'approve' : 'reject', comment },
    withCredentials,
  );
  return res.data;
}

/** The saved offer letter, as the candidate would receive it. */
export async function getOfferDraftPdf(applicationId) {
  const res = await axios.get(
    getApiUrl(`/api/hiring-lifecycle/applications/${applicationId}/offer-draft`),
    { ...withCredentials, responseType: 'blob' },
  );
  return res.data;
}

/** The server's explanation for a refused request, or a fallback. */
export const approvalError = (err, fallback) => err?.response?.data?.error || fallback;
